import { ComponentProps } from "react";
import * as S from "./styles";

interface IRadioSquareProps extends ComponentProps<"input"> {
  label: string;
}
export const RadioSquare = ({ label, ...rest }: IRadioSquareProps) => {
  return (
    <S.WrapperRadioSquare>
      {rest?.checked ? (
        <img src="/assets/svgs/check-box-fill.svg" alt="check" />
      ) : (
        <img src="/assets/svgs/check-box.svg" alt="check" />
      )}
      <S.RadioSquareItem {...rest} type="radio" />
      <span>{label}</span>
    </S.WrapperRadioSquare>
  );
};
